/**
 * KeyboardNavigationFeature - Enhanced keyboard navigation with visible focus
 */
import BaseFeature from './BaseFeature.js';

export default class KeyboardNavigationFeature extends BaseFeature {
    constructor(widget, options = {}) {
        super(widget, options);
        this._keydownHandler = null;
    }

    enable() {
        super.enable();
        this.addBodyClass('dhA11y-keyboard-navigation');
        this._bindKeyboard();
    }

    disable() {
        super.disable();
        this.removeBodyClass('dhA11y-keyboard-navigation');
        this._unbindKeyboard();
    }

    /**
     * Bind keyboard navigation enhancements
     */
    _bindKeyboard() {
        this._keydownHandler = (e) => {
            // Tab key was pressed - show focus styles
            if (e.key === 'Tab') {
                document.body.classList.add('dhA11y-tab-focus');
            }
        };

        this._mousedownHandler = () => {
            // Mouse was used - hide focus styles
            document.body.classList.remove('dhA11y-tab-focus');
        };

        document.addEventListener('keydown', this._keydownHandler);
        document.addEventListener('mousedown', this._mousedownHandler);

        // Make all interactive elements tabbable
        this._enhanceTabIndex();
    }

    /**
     * Unbind keyboard navigation
     */
    _unbindKeyboard() {
        if (this._keydownHandler) {
            document.removeEventListener('keydown', this._keydownHandler);
            this._keydownHandler = null;
        }
        if (this._mousedownHandler) {
            document.removeEventListener('mousedown', this._mousedownHandler);
            this._mousedownHandler = null;
        }
        document.body.classList.remove('dhA11y-tab-focus');
    }

    /**
     * Enhance tab index on interactive elements
     */
    _enhanceTabIndex() {
        // Ensure clickable elements are tabbable
        document.querySelectorAll('[onclick]:not([tabindex])').forEach(el => {
            el.setAttribute('tabindex', '0');
            el.dataset.a11yTabEnhanced = 'true';
        });
    }
}
